<div mat-dialog-content style="display:flex; flex-direction:row; align-items:center; justify-content:center;">
    <div id="content" style="max-height: 500px; max-width: 80%;"></div>
 </div>
 <br>
 <div mat-dialog-actions style="display:flex; flex-direction:row-reverse; justify-content:space-between; align-items:center;">
    <button *ngIf="onlyOk === true" mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>
        <div style="display:flex; flex-direction:row; align-items:center;">
            Ok
            <mat-icon class="material-icons">done</mat-icon>
        </div>
    </button>

   <button *ngIf="onlyOk === false" mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>
    <div style="display:flex; flex-direction:row; align-items:center;">
        {{yes}}
        <mat-icon class="material-icons">done</mat-icon>
    </div>
    </button>

   <button *ngIf="onlyOk === false" mat-raised-button color="warn"  (click)="onNoClick()">
    <div style="display:flex; flex-direction:row; align-items:center;">
        {{no}}
        <mat-icon class="material-icons">close</mat-icon>
    </div>
    </button>
 </div>